import { ToolType } from './shows.model';

/** The translation key naming a tool's type. "Video" is already translated in the unscoped file. */
export function toolTypeKey(type: ToolType): string {
  return type === 'video' ? 'common.video' : 'tools.tool_type.' + type;
}
